'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var nthHookSettings = require('@narvar/nth-hook-settings');
var TelephoneInput = require('@narvar/nth-block-telephone-input');
var Checkbox = require('@narvar/nth-block-checkbox');
var Button = require('@narvar/nth-block-button');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var MustacheNestedRender = require('@narvar/nth-bit-mustache-nested-render');
var types = require('../../../types.js');
var NotificationPreferencesOptin = require('./NotificationPreferencesOptin.js');
var index = require('../../../index.js');
var TemplateLinkContext = require('../../common/TemplateLinkContext.js');
var useConsumerPreferences = require('../../../hooks/useConsumerPreferences.js');
var SMSOptinForm_module = require('./SMSOptinForm.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var TelephoneInput__default = /*#__PURE__*/_interopDefaultLegacy(TelephoneInput);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var MustacheNestedRender__default = /*#__PURE__*/_interopDefaultLegacy(MustacheNestedRender);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const SMSOptIn = ({
  onOptIn,
  onChange,
  featureName,
  validationError,
  layout,
  notificationPreferencesState,
  consumerPreferencesOptinEnabled = false,
  retailerMarketingOptinEnabled
}) => {
  const {
    preferenceLevel
  } = notificationPreferencesState ?? {};
  const {
    optinEnabled
  } = useConsumerPreferences.useConsumerPreferences();
  const [retailerLevelChecked, setRetailerLevelChecked] = React.useState(preferenceLevel === types.PreferenceLevels.RETAILER);
  const [marketingOptInChecked, setMarketingOptInChecked] = React.useState(false);
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [notificationPreferencesChecked, setnotificationPreferencesChecked] = React.useState(consumerPreferencesOptinEnabled);
  React.useEffect(() => {
    if (!consumerPreferencesOptinEnabled) return;
    setnotificationPreferencesChecked(consumerPreferencesOptinEnabled);
  }, [consumerPreferencesOptinEnabled]);
  const {
    notificationCenter
  } = nthHookSettings.useSettings();
  const {
    marketingOptInPrivacyLink = '',
    marketingOptInTermsLink = ''
  } = notificationCenter ?? {};
  const {
    retailerLevelOptInEnabled,
    retailerName
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    bodytextDefaultNone: bodyTextStyle,
    captiontextErrorNone: errorTextStyle,
    linksNoneDefault: linkStyle,
    linksNoneHover: linkeHoverStyle
  } = nthHookTheme.useTheme();
  const {
    notificationCenterMarketingOptInText,
    notificationCenterSmsDisclaimerText,
    notificationCenterSmsDisclaimerTextMarketing,
    notificationCenterSmsInputLabel,
    notificationCenterSmsSignupButton,
    notificationCenterSmsValidationErrorMessage,
    notificationCenterRetailerLevelSubscribeOption,
    notificationCenterSublimeErrorMessage
  } = nthHookTranslations.useTranslations();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  const marketingOptInAnalytics = {
    clickNotificationMarketingOptInChecked: marketingOptInChecked,
    clickNotificationMarketingPrivacyLink: marketingOptInPrivacyLink,
    clickNotificationMarketingTermsLink: marketingOptInTermsLink,
    clickNotificationMarketingOptInText: mustache__default["default"].render(notificationCenterMarketingOptInText || '', {
      retailerName,
      privacyLink: true,
      termsLink: true
    })
  };
  const handleSubmit = event => {
    event.preventDefault();
    const clickNotificationOptInDisclaimerText = mustache__default["default"].render((retailerMarketingOptinEnabled ? notificationCenterSmsDisclaimerTextMarketing : notificationCenterSmsDisclaimerText) ?? '', {
      retailerName
    });
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.SMS_SIGNUP,
      clickNotificationIsOptIn: true,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.SMS_SIGNUP,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
      clickNotificationOptInDisclaimerText,
      ...(retailerMarketingOptinEnabled ? marketingOptInAnalytics : {})
    });
    onOptIn(phoneNumber, retailerLevelChecked, marketingOptInChecked, notificationPreferencesChecked);
  };
  const handleNotificationPreferencesChange = () => {
    setnotificationPreferencesChecked(prevValue => !prevValue);
    onChange();
  };
  const handlePhoneNumberChange = number => {
    setPhoneNumber(number);

    // This is a hack because TelephoneInput useEffect's dependency arrays are
    // not exhaustive and are firing change events on load
    if (number.length > 0) onChange();
  };
  const showMarketingOptinCheckbox = retailerMarketingOptinEnabled && !consumerPreferencesOptinEnabled;
  const showRetailerLevelOptinCheckbox = retailerLevelOptInEnabled && (preferenceLevel === types.PreferenceLevels.RETAILER || preferenceLevel === types.PreferenceLevels.ORDER);
  return /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: SMSOptinForm_module["default"].smsOptinFormContainer
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-one-${isLandscape ? '7' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? '7' : '12'}`
    }
  }, /*#__PURE__*/React__default["default"].createElement(TelephoneInput__default["default"], {
    label: notificationCenterSmsInputLabel ?? '',
    title: notificationCenterSmsInputLabel ?? '',
    centered: !isLandscape,
    error: validationError !== undefined,
    onChangeCallback: handlePhoneNumberChange,
    featureName: featureName,
    s: validationError ? {
      border: `1px solid ${errorTextStyle?.color ?? ''}`
    } : undefined
  }), validationError && /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "smsOptInValidationErrorContainer",
    style: {
      ...bodyTextStyle,
      ...errorTextStyle
    }
  }, validationError === index.ERROR_TYPES.SUBLIME_VALIDATION_ERROR ? notificationCenterSublimeErrorMessage : notificationCenterSmsValidationErrorMessage), showMarketingOptinCheckbox && /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    id: "marketingOptIn",
    onChange: () => setMarketingOptInChecked(!marketingOptInChecked),
    checked: marketingOptInChecked,
    containerStyle: {
      marginTop: '1rem'
    },
    labelTextCellStyle: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React__default["default"].createElement(MustacheNestedRender__default["default"], {
    template: mustache__default["default"].parse(notificationCenterMarketingOptInText ?? ''),
    context: new mustache__default["default"].Context({
      retailerName,
      privacyLink: () => TemplateLinkContext.templateLinkContext(marketingOptInPrivacyLink ?? '', linkStyle, linkeHoverStyle),
      termsLink: () => TemplateLinkContext.templateLinkContext(marketingOptInTermsLink ?? '', linkStyle, linkeHoverStyle)
    })
  })), showRetailerLevelOptinCheckbox && /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    id: "retailerLevel",
    onChange: () => setRetailerLevelChecked(!retailerLevelChecked),
    checked: retailerLevelChecked,
    containerStyle: {
      marginTop: '1rem'
    },
    labelTextCellStyle: {
      textAlign: 'left'
    }
  }, mustache__default["default"].render(notificationCenterRetailerLevelSubscribeOption ?? '', {
    retailerName
  }))), !isLandscape && optinEnabled && /*#__PURE__*/React__default["default"].createElement(NotificationPreferencesOptin["default"], {
    isLandscape: isLandscape,
    isChecked: notificationPreferencesChecked,
    onChange: handleNotificationPreferencesChange
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-two-${isLandscape ? '5' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? '5' : '12'}`
    }
  }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    featureName: featureName,
    big: true,
    type: Button.ButtonType.submit
  }, notificationCenterSmsSignupButton)), isLandscape && optinEnabled && /*#__PURE__*/React__default["default"].createElement(NotificationPreferencesOptin["default"], {
    isLandscape: isLandscape,
    isChecked: notificationPreferencesChecked,
    onChange: handleNotificationPreferencesChange
  })));
};
var SMSOptInForm = nthHookSettings.withSettingsProvider(nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(SMSOptIn, {
  themeTokens: ['bodytextDefaultNone', 'captiontextErrorNone', 'linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['notificationCenterMarketingOptInText', 'notificationCenterSmsDisclaimerText', 'notificationCenterSmsDisclaimerTextMarketing', 'notificationCenterSmsInputLabel', 'notificationCenterSmsSignupButton', 'notificationCenterSmsValidationErrorMessage', 'notificationCenterRetailerLevelSubscribeOption', 'notificationCenterSublimeErrorMessage']
}), {
  globalSettingsRequested: `
        retailerLevelOptInEnabled
        retailerName
      `
}), {
  settingsRequested: `
      notificationCenter {
        marketingOptInEnabled
        marketingOptInPrivacyLink
        marketingOptInTermsLink
      }
    `
});

exports.SMSOptIn = SMSOptIn;
exports["default"] = SMSOptInForm;
